import { Target, TrendingUp, Zap, Shield, Heart } from "lucide-react";
import styles from "./About.module.css";

const About = () => {
  return (
    <main>
      {/* Hero Section */}
      <section className={styles.aboutHero}>
        <div className="container">
          <div className={styles.heroContent}>
            <h1 className={styles.heroTitle}>
              Empowering Professionals to{" "}
              <span className={styles.highlight}>Master Their Skills</span>
            </h1>
            <p className={styles.heroDescription}>
              We're on a mission to democratize skill development through
              personalized assessments, AI-powered learning paths, and
              data-driven insights that accelerate career growth.
            </p>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className={styles.missionSection}>
        <div className="container">
          <div className={styles.missionContent}>
            <div className={styles.missionItem}>
              <div className={styles.missionIcon}>
                <Target size={48} />
              </div>
              <div className={styles.missionText}>
                <h2>Our Mission</h2>
                <p>
                  To democratize professional development by providing
                  personalized, data-driven skill assessments and learning paths
                  that help individuals identify their strengths, bridge skill
                  gaps, and accelerate their career growth.
                </p>
              </div>
            </div>
            <div className={styles.missionItem}>
              <div className={styles.missionIcon}>
                <Heart size={48} />
              </div>
              <div className={styles.missionText}>
                <h2>Our Vision</h2>
                <p>
                  A world where every professional has access to personalized
                  learning experiences that unlock their full potential and
                  create meaningful career opportunities regardless of their
                  background or location.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What We Do */}
      <section className={styles.servicesSection}>
        <div className="container">
          <div className={styles.sectionHeader}>
            <h2 className={styles.sectionTitle}>What We Do</h2>
            <p className={styles.sectionSubtitle}>
              Comprehensive skill development platform powered by AI and expert
              insights
            </p>
          </div>
          <div className={styles.servicesGrid}>
            <div className={styles.serviceCard}>
              <div className={styles.serviceIcon}>
                <Zap size={40} />
              </div>
              <h3>AI-Powered Assessments</h3>
              <p>
                Advanced algorithms analyze your performance across multiple
                dimensions to provide accurate skill evaluations and
                personalized recommendations.
              </p>
            </div>
            <div className={styles.serviceCard}>
              <div className={styles.serviceIcon}>
                <TrendingUp size={40} />
              </div>
              <h3>Personalized Learning Paths</h3>
              <p>
                Custom-tailored learning journeys that adapt to your pace,
                preferences, and career goals for maximum efficiency and
                engagement.
              </p>
            </div>
            <div className={styles.serviceCard}>
              <div className={styles.serviceIcon}>
                <Shield size={40} />
              </div>
              <h3>Expert-Designed Content</h3>
              <p>
                Industry professionals and learning experts collaborate to
                create high-quality assessments and educational materials.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className={styles.ctaSection}>
        <div className="container">
          <div className={styles.ctaContent}>
            <h2>Ready to Master Your Skills?</h2>

            <div className={styles.ctaButtons}>
              <a href="/login" className={`${styles.btn} ${styles.btnPrimary}`}>
                Start Your Journey
              </a>
              <a
                href="/contact"
                className={`${styles.btn} ${styles.btnSecondary}`}
              >
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default About;
